import { useLocation } from 'react-router-dom';
import ProductCards from './ProductCards';
import Breadcrumbs from './Breadcrumbs';
import { CartContext } from '../context/cartContext';
import { useContext, useEffect, useState } from 'react';
import { Product } from '../interface/interface';
import { generateSearchBreadcrumbs } from '../utils/generateSearchBreadCrumbs';
import { frameProductObject } from '../utils/framePrductObject';

const RenderSearchedContent = () => {
  const location = useLocation();
  const { addCart, removeCart, cart } = useContext(CartContext);
  const [products, setProducts] = useState<Array<Product>>([]);

  useEffect(() => {
    if (!location.state?.selectedProduct?.length) {
      setProducts([]);
      return;
    }
    setProducts(
      frameProductObject(location.state?.selectedProduct, cart?.line_items),
    );
  }, [location.state?.selectedProduct, cart]);

  return (
    <div>
      <Breadcrumbs
        data={[
          {
            tag: 'a',
            className: 'mr-3',
            href: '/home',
            children: <>Home</>,
          },
          ...generateSearchBreadcrumbs(location.state),
        ]}
      />

      <div className="result-block-container">
        <ul className="grid grid-cols-1 gap-6 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-4">
          {products.length ? (
            products?.map((product: Product) => (
              <div key={product.id}>
                <ProductCards
                  product={product}
                  addProductToCart={addCart}
                  removeProductFromCart={removeCart}
                  isAccessories={false}
                  allowedProduct={false}
                  isGuest={false}
                />
              </div>
            ))
          ) : (
            <p>There is no combination of products exists</p>
          )}
        </ul>
      </div>
    </div>
  );
};

export default RenderSearchedContent;
